import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getAdminAuth } from '../utils/auth';
import { isBusinessUser } from '../utils/UtilityFunctions';

/**
 * Protects end-user routes (e.g. /profile). Blocks admin from accessing; blocks unauthenticated users.
 * Redirects business users with incomplete profile to /profile/business.
 */
function ProtectedRoute({ children }) {
  const navigate = useNavigate();
  const isLoggedIn = useSelector((state) => state.utilityReducer?.isLoggedIn);
  const loginData = useSelector((state) => state.loginReducer?.loginData);
  const businessOnboardingComplete = useSelector(
    (state) => state.utilityReducer?.businessOnboardingComplete
  );

  const isBusiness = isBusinessUser();
  const isBusinessProfileComplete =
    businessOnboardingComplete ||
    loginData?.status === 'profile_completed' ||
    loginData?.status === 'approved';
  const isIncompleteBusiness = isBusiness && !isBusinessProfileComplete;

  useEffect(() => {
    if (getAdminAuth()) {
      navigate('/admin/dashboard', { replace: true });
      return;
    }
    if (!isLoggedIn) {
      navigate('/', { replace: true });
      return;
    }
    if (isIncompleteBusiness) {
      navigate('/profile/business', { replace: true });
    }
  }, [isLoggedIn, isIncompleteBusiness, navigate]);

  if (getAdminAuth() || !isLoggedIn || isIncompleteBusiness) {
    return null;
  }

  return children;
}

export default ProtectedRoute;
